import React, { useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useLocation, useNavigate } from "react-router-dom";
//Redux
import { useSelector } from "react-redux"; //useDispatch

//Components
import { InputField } from "../../../../Components/formElements/InputField";
import Constants from "../../../../common/SupplierConstants";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
import Layout from "../../../../Layout/Layout";
import DataTable from "react-data-table-component";

const Partners360Details = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { partnerData, formData: modalFormData } = location.state || {};
  localStorage.setItem("menu", "Employee");
  localStorage.setItem("submenu", "Employee Master");
  let userData = useSelector((state) => state?.user?.data);
  /* pop failure modal */
  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };

  const [isCardVisible1, setCardVisible1] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);
  const [isCardVisible4, setCardVisible4] = useState(true);
  const [isCardVisible5, setCardVisible5] = useState(true);
  const [isCardVisible6, setCardVisible6] = useState(true);
  const [isCardVisible7, setCardVisible7] = useState(true);
  const [isCardVisible8, setCardVisible8] = useState(true);
  const [getFailureModal] = useState(failureModalData);
  const [getShowFailureModal, setShowFailureModal] = useState(false);
  // eslint-disable-next-line
  const [getErrorFields, setErrorFields] = useState([]);
  const [validation, setValidation] = useState({
    erpVendorId: "",
    routeNumber: "",
    commission: "Yes",
    // commissionRate: "",
  });
  const toggleCardVisibility = () => {
    setCardVisible1(!isCardVisible1);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };
  const toggleCardVisibility4 = () => {
    setCardVisible4(!isCardVisible4);
  };
  const toggleCardVisibility5 = () => {
    setCardVisible5(!isCardVisible5);
  };
  const toggleCardVisibility6 = () => {
    setCardVisible6(!isCardVisible6);
  };
  const toggleCardVisibility7 = () => {
    setCardVisible7(!isCardVisible7);
  };
  const toggleCardVisibility8 = () => {
    setCardVisible8(!isCardVisible8);
  };
  const onInputChange = ({ target: { name, value } }) => {
    const errors = {};
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
    setValidation((prev) => ({
      ...prev,
      [name]: errors[name] || "",
    }));
  };

  let EvaluationDetailsColum = [
    {
      local_id: 1,
      form: 1,
      to: "",
      description: "",
    },
  ];

  const [/*evaluationDetails,*/ setEvaluationDetails] = useState(
    EvaluationDetailsColum,
  );

  const addEvaluationDetails = () => {
    setEvaluationDetails((prevRows) => {
      EvaluationDetailsColum[0].local_id = prevRows.length + 1;
      EvaluationDetailsColum[0].inquiryDocumentItemNr = prevRows.length + 1;
      return [...prevRows, ...EvaluationDetailsColum];
    });
  };

  const [formInputs, setFormInputs] = useState({
    createdBy: userData?.userId || "",
    erpVendorId: partnerData?.userId || "",
    organisationName: partnerData?.organisationName || "",
    country: partnerData?.country || "IN",
    address: partnerData?.address,
    cityPostalCode: partnerData?.cityPostalCode || "",
    contactPerson: partnerData?.contactfirstName || "",
    contactPersonPhone: partnerData?.contactNumber || "",
    email: partnerData?.email || "",
    auditYear: modalFormData?.year || "",
    year: modalFormData?.year || "",
    companyCode: partnerData?.companyCode || "",
    version: partnerData?.version || "v0",
    status: partnerData?.status || "Registered",
    commission: "Yes",
    activeInactive: true,
  });
  const hideFailureModal = () => {
    setShowFailureModal(false);
  };

  // eslint-disable-next-line no-unused-vars
  const navigateToLogin = () => {
    navigate(Constants.LOGIN);
  };
  const evaluationDetailsCol = [
  {
    name: "S. No.",
    selector: (row) => row.serialNo,
    sortable: true,
    width: "100px",
  },
  {
    name: "Checklist Item",
    selector: (row) => row.checklistItem,
    sortable: true,
    width: "250px",
  },
  {
    name: "Description",
    selector: (row) => row.description,
    sortable: true,
    width: "300px",
  },
  {
    name: "Responsible Person",
    selector: (row) => row.responsiblePerson,
    sortable: true,
    width: "180px",
  },
  {
    name: "Deadline",
    selector: (row) => row.deadline,
    sortable: true,
    width: "180px",
  },
  {
    name: "Remarks",
    selector: (row) => row.remarks,
    sortable: true,
    width: "220px",
  },
  {
    name: "Status",
    selector: (row) => row.status,
    sortable: true,
    width: "120px",
  },
];

const evaluationData = [
  {
    id: 1,
    serialNo: "1",
    checklistItem: "Verify vendor license",
    description: "Check license validity",
    responsiblePerson: "Rajesh",
    deadline: "2025-05-23",
    remarks: "Pending",
    status: "✔",
  },
  {
    id: 2,
    serialNo: "2",
    checklistItem: "Check past performance",
    description: "Review vendor history",
    responsiblePerson: "Priya",
    deadline: "2025-05-14",
    remarks: "Completed",
    status: "✘",
  },
  {
    id: 3,
    serialNo: "3",
    checklistItem: "Evaluate delivery time",
    description: "Assess timely delivery",
    responsiblePerson: "Amit",
    deadline: "2025-05-12",
    remarks: "Pending",
    status: "✔",
  },
  {
    id: 4,
    serialNo: "4",
    checklistItem: "Inspect product quality",
    description: "Check material quality",
    responsiblePerson: "Sneha",
    deadline: "2025-05-16",
    remarks: "Follow-up required",
    status: "✘",
  },
  {
    id: 5,
    serialNo: "5",
    checklistItem: "Review financial stability",
    description: "Verify credit history",
    responsiblePerson: "Karan",
    deadline: "2025-04-29",
    remarks: "Completed",
    status: "✔",
  },
  {
    id: 6,
    serialNo: "6",
    checklistItem: "Confirm compliance",
    description: "Ensure legal adherence",
    responsiblePerson: "Divya",
    deadline: "2025-05-15",
    remarks: "Completed",
    status: "✘",
  },
];
  const auditScoreDescriptionColumns = [
    {
      name: "Value",
      selector: (row) => row.value,
      sortable: true,
      width: "200px",
    },
    {
      name: "Description",
      selector: (row) => row.description,
      sortable: true,
      width: "300px",
    },
  ];

  const auditScoreDescriptionData = [
    {
      id: 1,
      value: "-",
      description: "No Rating",
    },
    {
      id: 2,
      value: "A",
      description: "Excellent",
    },
    {
      id: 3,
      value: "B",
      description: "Good.",
    },
    {
      id: 4,
      value: "C",
      description: "Average",
    },
    {
      id: 5,
      value: "D",
      description: "Poor",
    },
  ];

  const financialHealthColumns = [
  {
    name: "Sl No",
    selector: (row) => row.slNo,
    sortable: true,
    width: "120px",
  },
  {
    name: "Methods to Analyze Financial Health",
    selector: (row) => row.method,
    sortable: true,
    width: "500px",
  },
];

const financialHealthData = [
  {
    id: 1,
    slNo: "1",
    method: "Review Financial Statements",
  },
  {
    id: 2,
    slNo: "2",
    method: "Measure Liquidity Ratios",
  },
  {
    id: 3,
    slNo: "3",
    method: "Check Profitability Ratios",
  },
  {
    id: 4,
    slNo: "4",
    method: "Monitor Cash Flow",
  },
  {
    id: 5,
    slNo: "5",
    method: "Evaluate Debt Ratios",
  },
  {
    id: 6,
    slNo: "6",
    method: "Check Efficiency Ratios",
  },
  {
    id: 7,
    slNo: "7",
    method: "Benchmark with Industry Standards",
  },
  {
    id: 8,
    slNo: "8",
    method: "Conduct Trend Analysis",
  },
  {
    id: 9,
    slNo: "9",
    method: "Use Break-Even Analysis",
  },
  {
    id: 10,
    slNo: "10",
    method: "Audit Internal Controls",
  },
];

const awardsColumns = [
  {
    name: "Year",
    selector: (row) => row.year,
    sortable: true,
    width: "200px",
  },
  {
    name: "Visualizer",
    selector: (row) => row.visualizer,
    sortable: true,
    width: "300px",
  },
  {
    name: "Award Details",
    selector: (row) => row.awardDetails,
    sortable: true,
    width: "500px",
  },
];

const awardsData = [
  {
    id: 1,
    year: "2021",
    visualizer: "Gold Star",
    awardDetails: "Best Supplier Performance Award",
  },
  {
    id: 2,
    year: "2022",
    visualizer: "Silver Badge",
    awardDetails: "Outstanding Quality Achievement",
  },
  {
    id: 3,
    year: "2023",
    visualizer: "Trophy",
    awardDetails: "Excellence in Delivery Management",
  },
  {
    id: 4,
    year: "2024",
    visualizer: "Certificate",
    awardDetails: "Top Vendor Recognition Award",
  },
];

const acceptedRejectedColumns = [
  {
    name: "Year",
    selector: (row) => row.year,
    sortable: true,
    width: "180px",
  },
  {
    name: "Quarter",
    selector: (row) => row.quarter,
    sortable: true,
    width: "180px",
  },
  {
    name: "Material Group",
    selector: (row) => row.materialGroup,
    sortable: true,
    width: "300px",
  },
  {
    name: "Rejection Percentage (%)",
    selector: (row) => row.rejectionPercentage,
    sortable: true,
    width: "250px",
  },
];

const acceptedRejectedData = [
  {
    id: 1,
    year: "2022",
    quarter: "Q1",
    materialGroup: "Electrical",
    rejectionPercentage: "2%",
  },
  {
    id: 2,
    year: "2022",
    quarter: "Q2",
    materialGroup: "Mechanical",
    rejectionPercentage: "5%",
  },
  {
    id: 3,
    year: "2023",
    quarter: "Q3",
    materialGroup: "Packaging",
    rejectionPercentage: "3%",
  },
  {
    id: 4,
    year: "2024",
    quarter: "Q4",
    materialGroup: "Raw Materials",
    rejectionPercentage: "1%",
  },
];

const otdInfoColumns = [
  {
    name: "Year",
    selector: (row) => row.year,
    sortable: true,
    width: "180px",
  },
  {
    name: "OnTime Delivery Count",
    selector: (row) => row.onTimeDeliveryCount,
    sortable: true,
    width: "250px",
  },
  {
    name: "Late Delivery Count",
    selector: (row) => row.lateDeliveryCount,
    sortable: true,
    width: "250px",
  },
  {
    name: "On Time Delivery Percentage (%)",
    selector: (row) => row.onTimeDeliveryPercentage,
    sortable: true,
    width: "300px",
  },
];

const otdInfoData = [
  {
    id: 1,
    year: "2021",
    onTimeDeliveryCount: "120",
    lateDeliveryCount: "10",
    onTimeDeliveryPercentage: "92%",
  },
  {
    id: 2,
    year: "2022",
    onTimeDeliveryCount: "150",
    lateDeliveryCount: "15",
    onTimeDeliveryPercentage: "90%",
  },
  {
    id: 3,
    year: "2023",
    onTimeDeliveryCount: "180",
    lateDeliveryCount: "8",
    onTimeDeliveryPercentage: "96%",
  },
  {
    id: 4,
    year: "2024",
    onTimeDeliveryCount: "200",
    lateDeliveryCount: "5",
    onTimeDeliveryPercentage: "98%",
  },
];
  return (
    <main className="dashboard main sri-venkateshwara" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">Partners 360</h2>
            <p className="subText">
              {/* Register as a new Employee or Sub-Employee with our Company */}
            </p>
            <hr />
            {/* customer details */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible1
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">PD</span>
                    </Col>
                    <Col xs={8} md={8} lg={8}>
                      <span className="headerTitle">Partners</span>
                      <span className="subHeaderTitle">Partners Details</span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible1 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Erp Vendor Id"
                          label={
                            <>
                              <i className="bi bi-upc labelIcon"></i>
                              Vendor Id
                            </>
                          }
                          name="erpVendorId"
                          placeholder=""
                          value={formInputs?.erpVendorId || ""}
                          onChange={onInputChange}
                          required={true}
                          error={validation?.erpVendorId}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label={
                            <>
                              <i className="bi bi-building labelIcon"></i>
                              Vendor Name
                            </>
                          }
                          name="organisationName"
                          type="text"
                          placeholder=""
                          value={formInputs?.organisationName || ""}
                          onChange={onInputChange}
                          error={validation.organisationName}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Country"
                          label={
                            <>
                              <i className="bi bi-globe labelIcon"></i>
                              Country
                            </>
                          }
                          name="country"
                          placeholder=""
                          value={formInputs.country || ""}
                          onChange={onInputChange}
                          error={validation.country}
                          required={true}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Street"
                          label={
                            <>
                              <i className="bi bi-geo-alt labelIcon"></i>
                              Street
                            </>
                          }
                          name="street"
                          placeholder=""
                          value={formInputs.address || ""}
                          onChange={onInputChange}
                          error={validation.address}
                          required={true}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Postal Code"
                          label={
                            <>
                              <i className="bi bi-mailbox labelIcon"></i>
                              Postal Code
                            </>
                          }
                          name="cityPostalCode"
                          placeholder=""
                          value={formInputs.cityPostalCode || ""}
                          onChange={onInputChange}
                          error={validation.cityPostalCode}
                          required={true}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Contact Person"
                          label={
                            <>
                              <i className="bi bi-person labelIcon"></i>
                              Contact Person
                            </>
                          }
                          name="contactPerson"
                          placeholder=""
                          value={formInputs.contactPerson}
                          onChange={onInputChange}
                          error={validation.contactPerson}
                          required={true}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Contact Person Phone"
                          label={
                            <>
                              <i className="bi bi-telephone labelIcon"></i>
                              Contact Person Phone
                            </>
                          }
                          name="contactPersonPhone"
                          placeholder=""
                          value={formInputs.contactPersonPhone}
                          error={validation.contactPersonPhone}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Audit Results"
                          label={
                            <>
                              <i className="bi bi-clipboard-data labelIcon"></i>
                              Audit Results
                            </>
                          }
                          name="auditResults"
                          placeholder=""
                          value={formInputs.auditResults}
                          error={validation.auditResults}
                          onChange={onInputChange}
                          // disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Audit Year"

                          label={
                            <>
                              <i className="bi bi-calendar labelIcon"></i>
                              Audit Year
                            </>
                          }
                          name="auditYear"
                          placeholder=""
                          value={formInputs.auditYear}
                          error={validation.auditYear}
                          onChange={onInputChange}
                          // disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Deactivated"
                          label={
                            <>
                              <i className="bi bi-slash-circle labelIcon"></i>
                              Deactivated
                            </>
                          }
                          name="deactivated"
                          placeholder=""
                          value={formInputs.deactivated}
                          error={validation.deactivated}
                          onChange={onInputChange}
                          // disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Purchasing Block"
                          label={
                            <>
                              <i className="bi bi-lock labelIcon"></i>
                              Purchasing Block
                            </>
                          }
                          name="purchasingBlock"
                          placeholder=""
                          value={formInputs.purchasingBlock}
                          error={validation.purchasingBlock}
                          onChange={onInputChange}
                          // disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Finance Block"
                          label={
                            <>
                              <i className="bi bi-lock-fill labelIcon"></i>
                              Finance Block
                            </>
                          }
                          name="financeBlock"
                          placeholder=""
                          value={formInputs.financeBlock}
                          error={validation.financeBlock}
                          onChange={onInputChange}
                          // disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Icv Score"
                          label={
                            <>
                              <i className="bi bi-graph-up labelIcon"></i>
                              ICV Score
                            </>
                          }
                          name="icvScore"
                          placeholder=""
                          value={formInputs.icvScore}
                          error={validation.icvScore}
                          onChange={onInputChange}
                          // disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Financial Health Rating"
                          label={
                            <>
                              <i className="bi bi-bar-chart labelIcon"></i>
                              Financial Health Rating
                            </>
                          }
                          name="financialHealthRating"
                          placeholder=""
                          value={formInputs.financialHealthRating}
                          error={validation.financialHealthRating}
                          onChange={onInputChange}
                          // disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Financial Health Category"
                          label={
                            <>
                              <i className="bi bi-tags labelIcon"></i>
                              Financial Health Category
                            </>
                          }
                          name="financialHealthCategory"
                          placeholder=""
                          value={formInputs.financialHealthCategory}
                          error={validation.financialHealthCategory}
                          onChange={onInputChange}
                          // disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Year"
                          label={
                            <>
                              <i className="bi bi-calendar-event labelIcon"></i>
                              Year
                            </>
                          }
                          name="year"
                          placeholder=""
                          value={formInputs.year}
                          error={validation.year}
                          onChange={onInputChange}
                          // disabled={true}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/*Partners Evaluation Details*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible3
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility3}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">VD</span>
                    </Col>
                    <Col xs={4} md={8} lg={8}>
                      <span className="headerTitle">
                        Vendor Evaluation Details
                      </span>
                      <span className="subHeaderTitle">
                        Details of Vendors Evaluation
                      </span>
                    </Col>
                    <Col xs={4} md={2} lg={2} className="">
                      <button
                        className="btnTable"
                        onClick={addEvaluationDetails}
                      >
                        <i className="bi bi-plus-lg"></i> Add
                      </button>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible3 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    {" "}
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={evaluationDetailsCol}
                          data={evaluationData}
                          // progressPending={loading}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          selectableRows
                          // onSelectedRowsChange={handleChange}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/*Audit Score*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible5
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility5}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">AS</span>
                    </Col>
                    <Col xs={4} md={8} lg={8}>
                      <span className="headerTitle">Audit Score</span>
                      <span className="subHeaderTitle">
                        Details of Audit Score
                      </span>
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    {" "}
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={auditScoreDescriptionColumns}
                          data={auditScoreDescriptionData}
                          // progressPending={loading}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          selectableRows
                          // onSelectedRowsChange={handleChange}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/*Financial Health*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible6
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility6}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">FH</span>
                    </Col>
                    <Col xs={4} md={8} lg={8}>
                      <span className="headerTitle">Financial Health</span>
                      <span className="subHeaderTitle">
                        Details of Financial Health
                      </span>
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible6 ? "visible" : ""
                  }`}
                ></div>
                <Row>
                  <Col xs={12} md={12} lg={12}>
                    <DataTable
                      title=""
                       columns={financialHealthColumns}
      data={financialHealthData}
                      paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                      pagination
                      // paginationServer
                      // paginationTotalRows={totalRows}
                      // onChangeRowsPerPage={handlePerRowsChange}
                      // onChangePage={handlePageChange}
                      selectableRows
                      // onSelectedRowsChange={handleChange}
                    />
                  </Col>
                </Row>
              </div>
            </div>
            {/*Awards*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible7
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility7}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">A</span>
                    </Col>
                    <Col xs={4} md={8} lg={8}>
                      <span className="headerTitle">Awards</span>
                      <span className="subHeaderTitle">Details of Awards</span>
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible7 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    {" "}
                    {/* dynamicDropdown */}
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                           columns={awardsColumns}
      data={awardsData}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          selectableRows
                          // onSelectedRowsChange={handleChange}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/*OTD% Info*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">OI</span>
                    </Col>
                    <Col xs={4} md={8} lg={8}>
                      <span className="headerTitle">OTD% Info</span>
                      <span className="subHeaderTitle">
                        Details of OTD% Info
                      </span>
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    {" "}
                    {/* dynamicDropdown */}
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={otdInfoColumns}
      data={otdInfoData}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          selectableRows
                          // onSelectedRowsChange={handleChange}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/*Accepted v/s Rejected*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible8
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility8}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">AR</span>
                    </Col>
                    <Col xs={4} md={8} lg={8}>
                      <span className="headerTitle">Accepted v/s Rejected</span>
                      <span className="subHeaderTitle">
                        Details of Accepted v/s Rejected
                      </span>
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible8 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    {" "}
                    {/* dynamicDropdown */}
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                           columns={acceptedRejectedColumns}
      data={acceptedRejectedData}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          selectableRows
                          // onSelectedRowsChange={handleChange}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/*Non Conformance*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible4
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility4}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">NC</span>
                    </Col>
                    <Col xs={4} md={8} lg={8}>
                      <span className="headerTitle">Non Conformance</span>
                      <span className="subHeaderTitle">
                        Details of Non conformance
                      </span>
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible4 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    {" "}
                    {/* dynamicDropdown */}
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          //  columns={getPOLineItemsCol}
                          //  data={getPOLineItemsData}
                          // progressPending={loading}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          selectableRows
                          // onSelectedRowsChange={handleChange}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/*Non Conformance*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible4
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility4}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">C</span>
                    </Col>
                    <Col xs={4} md={8} lg={8}>
                      <span className="headerTitle">Contractor</span>
                      <span className="subHeaderTitle">
                        Details of Contractor
                      </span>
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible4 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    {" "}
                    {/* dynamicDropdown */}
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          //  columns={getPOLineItemsCol}
                          //  data={getPOLineItemsData}
                          // progressPending={loading}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          selectableRows
                          // onSelectedRowsChange={handleChange}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />
    </main>
  );
};

export default Partners360Details;
